// src/components/Layouts/BookingVehicleInfoCard/DesktopFooter.tsx
import React from "react";
import { Button } from "@mui/material";
import { FcInfo } from "react-icons/fc";
import { formatPriceWithCurrencySymbol } from "../../../helpers/getPriceWithCurrencySymbol";
import BookingGetters from "../../../store/onlineBooking/getters";

interface DesktopFooterProps {
  isDesktop: boolean;
  istabletScreen: boolean;
  isSmallScreen: boolean;
  totalPricePerDay: number;
  totalPrice: number;
  VehicleDetails: {
    dealerName: string;
    locationDescriptionName: string;
  };
  translate: (key: string) => string;
  isModalOpen: boolean;
  toggleModal: () => void;
  ModalComponent: React.FC<{
    isOpen: boolean;
    onClose: () => void;
    VehicleDetails: any;
  }>;
  BookButton: React.FC;
}

export const DesktopFooter: React.FC<DesktopFooterProps> = ({
  isDesktop,
  istabletScreen,
  isSmallScreen,
  totalPricePerDay,
  totalPrice,
  VehicleDetails,
  translate,
  isModalOpen,
  toggleModal,
  ModalComponent,
  BookButton,
}) => {
  const amountDetailsPerDay = formatPriceWithCurrencySymbol(
    BookingGetters.getCurrency(),
    totalPricePerDay
  );

  const amountDetailsTotal = formatPriceWithCurrencySymbol(
    BookingGetters.getCurrency(),
    totalPrice
  );

  return (
    <footer
      className="gap-2 box-border"
      style={
        isDesktop
          ? { height: "185px", backgroundColor: "#000000" }
          : istabletScreen
          ? { height: "146px", backgroundColor: "#000000" }
          : { backgroundColor: "#000000" }
      }
    >
      <div className="md:flex flex-wrap gap-2">
        <div className="md:gap-8 gap-0 w-full" style={{ margin: "4%" }}>
          <div style={{ float: "right" }}>
            <p className="text-[primary] text-md capitalize font-bold">
              <BookButton />
            </p>
          </div>

          <div
            className={`grid ${
              !isSmallScreen ? "gap-2" : ""
            } mb-1 justify-items-start box-border`}
          >
            <span
              className="md:text-md text-md"
              style={{
                fontFamily: "MBCorpoSText-Regular-Web-new",
                fontSize: "17px",
                fontWeight: "100",
                marginBottom: "-9px",
              }}
            >
              <p className="whitespace-nowrap text-[#FFFFFF]">
                {amountDetailsPerDay.price + amountDetailsPerDay.symbol}
                <span>{translate("/per day")}</span>
              </p>
            </span>

            <span
              className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
              style={{
                marginBottom: "5%",
                marginTop: isSmallScreen ? "7px" : "",
                fontFamily: "MBCorpoSText-CondBold-Web",
                fontSize: "20px",
              }}
            >
              <span>{translate("Total") + ":  "}</span>
              <span>{amountDetailsTotal.price}</span>
              <span>{amountDetailsTotal.symbol + " "}</span>
            </span>
          </div>
        </div>
      </div>

      <div style={{ marginLeft: "4%" }}>
        <div className="flex items-center">
          <span
            className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
            style={{
              fontFamily: "MBCorpoSText-CondLight-Web",
              fontSize: "15px",
              marginTop: "-11px",
              fontWeight: "100px",
            }}
          >
            <span style={{ fontFamily: "MBCorpoSText-CondLight-Web" }}>
              {VehicleDetails.dealerName}
            </span>
          </span>
        </div>

        <div className="flex items-center" style={{ marginTop: "-9px" }}>
          <span
            className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
            style={{
              fontFamily: "MBCorpoSText-CondLight-Web",
              fontSize: "15px",
              fontWeight: "100px",
            }}
          >
            {VehicleDetails.locationDescriptionName}
          </span>
          <span>
            <Button onClick={toggleModal}>
              <p
                className="text-md capitalize"
                style={{ color: "#0078D6", marginLeft: "-30px" }}
              >
                <FcInfo className="h-[20px] w-[20px]" />
              </p>
            </Button>
            <ModalComponent
              isOpen={isModalOpen}
              onClose={toggleModal}
              VehicleDetails={VehicleDetails}
            />
          </span>
        </div>
      </div>
    </footer>
  );
};
